module.exports = __webpack_public_path__ + "static/media/ad.738e62c3.svg";